import { Navigate, useParams, useLocation } from "react-router-dom";

export default function VieweRedirect() {
  const { rtoken } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const searchParams = query.toString();

  return <Navigate to={`/pub/${rtoken}/viewer?${searchParams}`} replace />
}